// extracted by mini-css-extract-plugin
module.exports = {"element":"_93444fe79c--element--QVN9u"};